import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import api from '../../api';
/* actions */
import { editSpecies } from '../../redux/actions/species';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/specie';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    description: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const species = useSelector(state => state.species);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/species', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0]
          };
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  const submit = () => {
    dispatch(editSpecies(data, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {species.editSuccess && (
        <AlertMsg type="success" msg="Espécie atualizada com sucesso" />
      )}
      {species.errorContent &&
        !species.errorContent.message.includes('400') &&
        species.editError && (
        <AlertMsg type="danger" msg="Falha durante atualização da espécie" />
      )}
      {species.errorContent &&
        species.errorContent.message.includes('400') &&
        species.editError && (
        <AlertMsg
          type="danger"
          msg="Uma espécie com o nome informado já está cadastrada"
        />
      )}
      {!species.editSuccess && !species.editError && (
        <AlertMsg type="info" msg="Área atualização de espécies" />
      )}
      <FormHeader title="Atualizar Espécie" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.name}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.description}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/species" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
